<div class="header">
  <h3>Welcome,&nbsp;{{ loggedInUserData?.contact?.name?.firstName }}</h3>
</div>
<app-filters></app-filters>
<app-table
  (nestedRowClicked)="toggleRefundData($event)"
  (exportOptionClicked)="export($event)"
></app-table>

<ng-template #amountCell let-row let-value="value" let-column>
  <span [ngbTooltip]="tipContent" tooltipClass="custom-tooltip">
    ${{ value | customFormatCurrency }}
    <ng-template #tipContent>
      <span>
        {{ 'paymentDetails.subTotal' | translate }}: ${{ row.amount | customFormatCurrency }}
        <br />
        {{ 'paymentDetails.technologyFee' | translate }}: ${{
          row.adjustmentAmount | customFormatCurrency
        }}
        <br />
        {{ 'paymentDetails.total' | translate }}: ${{ value | customFormatCurrency }}
      </span>
    </ng-template>
    <i class="bi bi-exclamation-circle mx-1 info-icon-only" placement="top"></i>
  </span>
</ng-template>
